import { Injectable } from '@angular/core';
import { BaseErrorMappingService } from '../base-error-mapping.service';
import type { ErrorRule } from '../../../models/error-mapping.model';

@Injectable({
  providedIn: 'root'
})
export class FeedbackErrorMappingService extends BaseErrorMappingService {
  protected rules: ErrorRule[] = [
    {
      pattern: /\/Feedback\/Send/,
      messages: {
        400: 'errors.sendFeedbackFailed',
        404: 'errors.sendFeedbackFailed',
        500: 'errors.sendFeedbackFailed',
        success: {
          default: 'errors.sendFeedbackFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    }
  ];
}
